import joinClassNames from './joinClassNames.js'

/**
 * Pill group for mutually exclusive selection (≤5 options).
 * Replaces dropdowns for time periods, eval type, view mode.
 *
 * @param {{
 *   options: { id: string, label: React.ReactNode }[]
 *   value: string
 *   onChange: (id: string) => void
 *   className?: string
 *   ariaLabel?: string
 * }} props
 */
export default function SegmentedControl({
  options,
  value,
  onChange,
  className = '',
  ariaLabel,
}) {
  return (
    <div
      className={joinClassNames('segmented-control', className)}
      role="group"
      aria-label={ariaLabel}
    >
      {options.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          className={joinClassNames('segmented-control-btn', value === id && 'active')}
          aria-pressed={value === id}
          onClick={() => onChange(id)}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
